module.exports = __webpack_public_path__ + "img/404.d04193f3.svg";